// extracted by mini-css-extract-plugin
export var dividerContainer = "_8e-0";
export var line = "_8e-1";